const URL = {
  // Admin editor preview + ordering modal. Authenticated; shop comes from the token.
  CATALOG_ADMIN: 'catalog/admin',
  CATALOG_ADMIN_TAGS: 'catalog/admin/tags',
  CATALOG_ORDER: 'catalog/{catalogId}/order',
}

export default URL
